export enum PanelTrimType {
	'ninety' = 'ninety',
	'fortyfive' = 'fortyfive',
	'straight' = 'straight'
}
